module.exports = __webpack_public_path__ + "img/Weapon_70.7459b7b4.png";